export const PersonelStatus = Object.freeze({
  available: 1,
  unavailable: 0,
});
